import type { onAfterSaveType } from 'app/main/components/hooks/useModel';
import { sendNotification } from 'app/store/notifications/notificationsHubSlice';
import DetailsEventsWrapper from 'app/main/components/page-layouts/details/components/DetailsEventsWrapper';

const sendSaveNotification: onAfterSaveType = ({ dispatch, model, modifiedModel }) =>
	new Promise<void>((resolve, reject) => {
		if (modifiedModel.tick_user_assigned_uid !== model.tick_user_modified_uid) {
			dispatch(
				sendNotification({
					message: {
						createdBy: modifiedModel.tick_user_modified_uid,
						assignedTo: modifiedModel.tick_user_assigned_uid,
						title: 'Nuovo Ticket assegnato',
						body: `Sei stato assegnato a "${model.tick_title}" da ${model.user_modified_title}.`,
						url: `${window.location.origin}/tickets/details/${model.tick_uid}`,
						icon: 'ticket',
						variant: 'info'
					}
				})
			);
		}

		resolve();
	});

const onAfterSave: onAfterSaveType = params => DetailsEventsWrapper(params)([sendSaveNotification]);

export default { onAfterSave };
